import { ReactNode } from 'react';

import { Styles, css } from '@flipster/styled-system/css';
import { center, vstack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';

interface Props {
  colorSet: 'normal' | 'keyColor';
  subtitle?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  css?: Styles;
}

export const SeparatorTitle = ({ colorSet, subtitle, title, description, css: cssProps }: Props) => {
  const variables: Record<string, string> = {
    '--separator-color': colorSet === 'normal' ? token('colors.content.default.level-5') : 'var(--key-color)',
  };

  return (
    <div
      className={css(vstack.raw({ pos: 'relative', w: '100%', gap: 16, py: 24, textAlign: 'center' }), cssProps)}
      style={variables}
    >
      <HSeparator css={{ pos: 'absolute', top: 0, display: { tablet: 'none' } }} />
      {subtitle && <p className={css({ textStyle: 'Title/S', color: 'content.default.level-5' })}>{subtitle}</p>}
      <div className={center({ pos: 'relative', w: '100%' })}>
        <HSeparator
          css={{ pos: 'absolute', top: '50%', transform: 'translateY(-50%)', display: { tabletDown: 'none' } }}
        />
        <h3
          className={css({
            textStyle: 'Display/XL',
            color: 'var(--separator-color)',
            bgColor: 'background.default.level-0',
            px: { tablet: 40 },
            zIndex: 1,
          })}
        >
          {title}
        </h3>
      </div>
      {description && (
        <p className={css({ textStyle: 'Text/L/Regular', color: 'content.default.level-3' })}>{description}</p>
      )}
      <HSeparator css={{ pos: 'absolute', bottom: 0, display: { tablet: 'none' }, mt: 8 }} />
    </div>
  );
};

interface HSeparatorProps {
  css?: Styles;
}

const HSeparator = ({ css: cssProps }: HSeparatorProps) => {
  return (
    <div
      role='separator'
      className={css(
        {
          h: 2,
          w: '100%',
          bg: {
            base: 'linear-gradient(90deg, transparent 0%, var(--separator-color) 50%, transparent 100%)',
            tablet:
              'linear-gradient(90deg, transparent 0%, var(--separator-color) 15%, var(--separator-color) 85%, transparent 100%)',
          },
        },
        cssProps,
      )}
    />
  );
};
